interface WordmarkProps {
  readonly className?: string;
}

export function Wordmark({ className = '' }: WordmarkProps) {
  return (
    <span className={`font-display-soft text-2xl font-semibold tracking-tight text-ink ${className}`}>
      Kasboek
    </span>
  );
}
